;(function (angular, _) {
  'use strict'

  class PaymentContainer {
    constructor (
      // Angular
      // Libs
      $uibModal,
      // Managers
      // Services
      ComputingService, PaymentService
      // Const
      // Resolved
    ) {
      this.uibModal = $uibModal
      this.computingService = ComputingService
      this.paymentService = PaymentService
    }

    deletePayment (payment) {
      let promise
      switch ((this.type || '').toLowerCase()) {
        case 'invoice':
          promise = this.paymentService.deleteInvoicePayment(this.element, payment._id)
          break
        case 'creditnote':
        case 'credit-note':
        case 'credit_note':
          promise = this.paymentService.deleteCreditNotePayment(this.element, payment._id)
          break
        default:
          promise = new Promise((resolve, reject) => {
            return reject(new Error(`Unhandled element type ${this.type}`))
          })
      }
      return promise.then((invoice) => {
        this._notify(invoice)
      })
    }

    updatePayment (payment) {
      let promise
      switch ((this.type || '').toLowerCase()) {
        case 'invoice':
          promise = this.paymentService.updateInvoicePayment(this.element, payment, payment._id)
          break
        case 'creditnote':
        case 'credit-note':
        case 'credit_note':
          promise = this.paymentService.updateCreditNotePayment(this.element, payment, payment._id)
          break
        default:
          promise = new Promise((resolve, reject) => {
            return reject(new Error(`Unhandled element type ${this.type}`))
          })
      }
      return promise.then((invoice) => {
        this._notify(invoice)
      })
    }

    addPayment () {
      let promise
      switch ((this.type || '').toLowerCase()) {
        case 'invoice':
          promise = this.paymentService.addInvoicePayment(this.element)
          break
        case 'creditnote':
        case 'credit-note':
        case 'credit_note':
          promise = this.paymentService.addCreditNotePayment(this.element)
          break
        default:
          promise = new Promise((resolve, reject) => {
            return reject(new Error(`Unhandled element type ${this.type}`))
          })
      }
      return promise.then((invoice) => {
        this._notify(invoice)
      })
    }

    isValid () {
      return this.element.balanceDue <= 0 && this.element.status !== 'paid'
    }

    setIsPaid() {
      this.element.status = 'paid'
      this.element.save()
    }

    toPaid () {
      return this.element.balanceDue >= 0 && this.element.status !== 'paid'
    }

    getTotalDiscount () {
      return this.computingService.getTotalDiscount(this.computingService.getDiscounts(this.element.lines))
    }

    getGlobalDiscountValue () {
      return this.computingService.getGlobalDiscountValue(this.element)
    }

    getInvoiceDiscountedTotal () {
      return this.computingService.getObjectDiscountedTotal(this.element.lines)
    }

    _notify (element) {
      if (this.update) {
        this.update({ $value: element })
        this.element.payments = element.payments
      }
    }
  }

  PaymentContainer.$inject = [
    // Angular
    // Libs
    '$uibModal',
    // Managers
    // Services
    'ComputingService', 'PaymentService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('paymentContainer', {
      bindings: {
        element: '<',
        readonly: '<',
        update: '&',
        type: '@?'
      },
      templateUrl: '/app/common/components/payment-container/components/payment-container.template.html',
      controller: PaymentContainer
    })
})(window.angular, window._)
